export default __webpack_public_path__ + "static/media/video-bg2.f9cf0b49.jpg";